import { createRouter, createWebHashHistory } from 'vue-router'
const Login = () => import('../pages/Login.vue')
const Register = () => import('../pages/Register.vue')
const Index = () => import('../pages/Index.vue')
const Note = () => import('../pages/Note.vue')
const RecycleBin = () => import('../pages/RecycleBin.vue')
const Profile = () => import('../pages/Profile.vue')
const ShareNote = () => import('../pages/ShareNote.vue')

export const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/Login'
    },
    {
      path: '/Login',
      component: Login
    },
    {
      path: '/Register',
      component: Register
    },
    {
      path: '/share/doc/content/:urlSlug',
      component: ShareNote
    },
    {
      path: '/Index',
      component: Index,
      children: [
        {
          path: '/Index/Note',
          component: Note
        },
        {
          path: '/Index/RecycleBin',
          component: RecycleBin
        },
        {
          path: '/Index/Profile',
          component: Profile
        }
      ]
    }
  ]
})
